import { render, staticRenderFns } from "./BaseTree.vue?vue&type=template&id=1487a120&scoped=true&"
import script from "./BaseTree.vue?vue&type=script&lang=js&"
export * from "./BaseTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487a120",
  null
  
)

export default component.exports